import React, { useEffect, useState } from "react";
import { Grid, Button } from "@material-ui/core";
import { navigate } from "@reach/router";
import { useStepData } from "../context";
import { uploadValidator, organizeValidator, matchValidator, errorsValidator } from "../steps/validation";
import { availableSteps } from "..";

type Validator = (data: any) => boolean;
type Validators = Record<string, Validator>;

const validators: Validators = {
  "Upload": uploadValidator,
  "Organize": organizeValidator,
  "Match": matchValidator,
  "Errors": errorsValidator,
};

const StepNavigation: React.FC = () => {
  const { stepData, stepName } = useStepData();
  const [isValid, setIsValid] = useState(false);
  const currentStepIndex = availableSteps.findIndex((step) => stepName === step);
  const notLastStep = currentStepIndex < availableSteps.length - 1;

  const [continueVisible, setContinueVisible] = useState(true);

  useEffect(() => {
    if (validators[stepName]) {
      setIsValid(validators[stepName](stepData));
    } else {
      setIsValid(true);
    }
  }, [stepData, validators, stepName]);

  const handleContinue = () => {
    if (currentStepIndex < availableSteps.length - 1) {
      navigate((availableSteps[currentStepIndex + 1] ?? "Unknown").toLowerCase());
    }
  };

  useEffect(() => {
    if (stepName === "Upload") {
      setContinueVisible(validators.Upload && validators.Upload(stepData));
    } else {
      setContinueVisible(true);
    }
  }, [stepName, stepData]);

  if (!continueVisible || ["Finalize", "Confirmation"].includes(stepName)) {
    return null;
  }

  return (
    <Grid item xs={12}>
      <Button
        data-cy="continue-button"
        variant="contained"
        color="primary"
        onClick={handleContinue}
        disabled={notLastStep && !isValid}
      >
        Continue
      </Button>
    </Grid>
  );
};

export default StepNavigation;
